// I18N — Mobile menu titles and category names are translated via react-i18next.
import React, { useEffect, Fragment, useState } from "react";
import axios from "axios";
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.css";
import { useProjects } from "../../api/ProjectsContext";
import HeaderProfileForm from "../HeaderProfileForm/HeaderProfileForm";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

const CATEGORIES = [
  "Agriculture",
  "Community Building",
  "Education",
  "Food",
  "Health",
  "Human Rights",
  "ICT",
  "Media & Journalism",
  "Water",
  "Health and Environmental Security",
];

const MobileMenu = () => {
  const { causesData } = useProjects();
  const { t } = useTranslation();

  const menus = [
    {
      id: 1,
      title: t("nav.home"),
      link: "/",
    },
    {
      id: 2,
      title: t("nav.explore"),
      link: "/projects",
      submenu: CATEGORIES.map((category, index) => ({
        id: index,
        title: t(`categories.${category}`, category),
        link: `/projects/category/${encodeURIComponent(category)}`,
      })),
    },
    {
      id: 5,
      title: t("nav.partners"),
      link: "/partners",
    },
    {
      id: 3,
      title: t("nav.pages"),
      link: "",
      submenu: [
        { id: 30, title: t("nav.about"), link: "/about" },
        { id: 31, title: t("nav.contact"), link: "/contact" },
        { id: 32, title: t("nav.howItWorks"), link: "/how-it-works" },
        { id: 33, title: t("nav.privacy"), link: "/privacy" },
        { id: 34, title: t("nav.terms"), link: "/terms" },
      ],
    },
    {
      id: 4,
      title: t("nav.login"),
      link: "https://dashboard.sokaab.com/login/",
    },
  ];
  const [openId, setOpenId] = useState(0);
  const [menuActive, setMenuState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuState(!menuActive)}>
            <i className="fa fa-close"></i>
          </div>
        </div>
        <ul className="responsivemenu">
          {menus.map((item, mn) => (
            <ListItem className={item.id === openId ? "active" : null} key={mn}>
              {item.submenu ? (
                <Fragment>
                  <p
                    onClick={() => setOpenId(item.id === openId ? 0 : item.id)}
                  >
                    <NavLink
                      onClick={() => {
                        ClickHandler();
                        if (item.id !== 3) setMenuState(false);
                      }}
                      to={item.link}
                    >
                      {item.title}
                    </NavLink>
                    <i
                      className={
                        item.id === openId
                          ? "fa fa-angle-up"
                          : "fa fa-angle-down"
                      }
                    ></i>
                  </p>
                  <Collapse
                    in={item.id === openId}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List className="subMenu">
                      {item.submenu.map((submenu, i) => (
                        <ListItem key={i}>
                          <NavLink
                            onClick={() => {
                              ClickHandler();
                              setMenuState(false);
                            }}
                            to={submenu.link}
                          >
                            {submenu.title}
                          </NavLink>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </Fragment>
              ) : (
                <NavLink
                  onClick={() => {
                    ClickHandler();
                    setMenuState(false);
                  }}
                  className="active"
                  to={item.link}
                >
                  {item.title}
                </NavLink>
              )}
            </ListItem>
          ))}
        </ul>
        <div className="px-3 pb-3 pt-2 d-flex justify-content-center">
          <LanguageSwitcher className="dark" />
        </div>
      </div>
      <div
        className="showmenu mobail-menu"
        onClick={() => setMenuState(!menuActive)}
      >
        <button type="button" className="navbar-toggler open-btn">
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
